import styles from "./Logout.module.css"
import { useAuth0 } from "@auth0/auth0-react"

export function Logout() {
  const { logout } = useAuth0()
  return (
    <div onClick={() => logout({ returnTo: window.location.origin })} className={styles.logout}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
        />
      </svg>
    </div>
  )
}
